/**
 * Constantes de negócio. Nunca repetir essas strings nas páginas.
 *
 * `tom` é o vocabulário de status do handoff: confirmado, pendente, reprovado,
 * conferencia, arquivado.
 */

export const STATUS_ARQUIVO = {
  recebido: { label: 'Recebido', tom: 'arquivado' },
  extraido: { label: 'Extraído', tom: 'conferencia' },
  em_revisao: { label: 'Em conferência', tom: 'conferencia' },
  confirmado: { label: 'Confirmado', tom: 'confirmado' },
  reprovado: { label: 'Reprovado', tom: 'reprovado' },
};

/** Motivos de pendência — espelham `MOTIVOS_PENDENCIA` no backend. */
export const MOTIVO_PENDENCIA = {
  guia_nao_encontrada: {
    label: 'Guia não encontrada',
    tom: 'reprovado',
    natureza: 'atencao',
    ajuda: 'A guia do arquivo não existe no Bioslab. Pode ser divergência de número.',
  },
  sem_protocolo: {
    label: 'Sem protocolo',
    tom: 'pendente',
    natureza: 'atencao',
    ajuda: 'A guia existe no Bioslab mas ainda não foi apresentada num protocolo.',
  },
  multiplos_protocolos: {
    label: 'Múltiplos protocolos',
    tom: 'pendente',
    natureza: 'atencao',
    ajuda: 'A guia resolveu para mais de um protocolo. Precisa de decisão humana.',
  },
  bioslab_indisponivel: {
    label: 'Bioslab indisponível',
    tom: 'arquivado',
    natureza: 'neutro',
    ajuda: 'A consulta falhou. A extração foi preservada — basta reprocessar.',
  },
};

export const STATUS_MODELO = {
  rascunho: { label: 'Rascunho', tom: 'arquivado' },
  aguardando_admin: { label: 'Aguardando admin', tom: 'pendente' },
  aprovado: { label: 'Aprovado', tom: 'confirmado' },
  rejeitado: { label: 'Rejeitado', tom: 'reprovado' },
  inativo: { label: 'Inativo', tom: 'arquivado' },
};

/** Hierarquia: admin > gestor > operador. */
export const PERFIL = {
  admin: {
    label: 'Administrador',
    tom: 'conferencia',
    descricao: 'Faz tudo, sobre todos. Cria outros administradores e é o único que vê a auditoria.',
  },
  gestor: {
    label: 'Gestor',
    tom: 'confirmado',
    descricao: 'Gerencia os operadores — cria, inativa, altera cadastro e reseta senha.',
  },
  operador: {
    label: 'Operador',
    tom: 'arquivado',
    descricao: 'Usa o sistema: lança recebimentos, confere e acompanha.',
  },
};
